export default "__VITE_ASSET__91lNdK3Y__"